import * as ewe from "@eyeo/webext-ad-filtering-solution";
import { STEP_PREF_KEY, TRIAL_START_DATE_PREF_KEY, } from "../shared/constants.js";
import { getLastStepId } from "./touchpoints.js";
export async function advanceTrialStep(params, newStep) {
    var _a;
    const currentStep = (_a = params.prefs.get(STEP_PREF_KEY)) !== null && _a !== void 0 ? _a : 0;
    if (currentStep < newStep) {
        await params.prefs.set(STEP_PREF_KEY, newStep);
    }
}
export async function startTrial(params) {
    await params.prefs.set(TRIAL_START_DATE_PREF_KEY, Date.now());
    await ewe.lightningSnippets.enable();
}
export async function endTrial(params, config) {
    await advanceTrialStep(params, getLastStepId(config));
    await ewe.lightningSnippets.clear();
}
